import { CellContext } from "@tanstack/react-table";
import { Intent } from "../../../__generated__/gql/graphql";
import { Compass, InfoSquare, ShoppingCart, Tag } from "../../../ui/Icon/Icon";
import toSentenceCase from "../../../util/toSentenceCase";
import styles from "./IntentCell.module.scss";
import Tooltip from "../../../ui/Tooltip/Tooltip";

const IntentIcons = {
  [Intent.Informational]: <InfoSquare size="xsmall" />,
  [Intent.Navigational]: <Compass size="xsmall" />,
  [Intent.Commercial]: <Tag size="xsmall" />,
  [Intent.Transactional]: <ShoppingCart size="xsmall" />,
};

const intentTooltips = {
  [Intent.Informational]:
    "Informational intent is when users seek specific information or answers to their questions, aiming to acquire knowledge about a particular topic or subject",
  [Intent.Navigational]:
    "Navigational intent occurs when users want to visit a specific website or access a particular online destination directly by entering its name or brand in the search",
  [Intent.Commercial]:
    "Commercial investigation intent involves users who are in the research phase, looking to gather information and compare options before making a purchase decision",
  [Intent.Transactional]:
    "Transactional intent refers to users who are actively searching with the intention of making a purchase or completing a specific action, often seeking products, services, or deals",
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function IntentCell({ cell }: CellContext<any, Intent | null | undefined>) {
  const value = cell.getValue();

  if (!value) {
    return null;
  }

  return (
    <Tooltip content={intentTooltips[value]}>
      <div className={styles.intent}>
        {IntentIcons[value]}
        <span>{toSentenceCase(value)}</span>
      </div>
    </Tooltip>
  );
}

export default IntentCell;
